<template xmlns="http://www.w3.org/1999/html">
    <div>
        <div class="card">
            <div class="card-header">
                <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
                New special day
            </div>
            <div class="card-block">
                <div class="row">
                    <!-- <div class="col-md-3">
                        <input type="date" class="form-control" v-model="newSpecialDate" :class="{'has-danger': !newSpecialDate}">
                    </div> -->
                    <div class="form-group col-md-3" :class="newSpecialDate ? 'has-success' : 'has-danger'">
                        <label class="col-md-3 form-control-label">Date</label>
                        <datepicker placeholder="yyyy-mm-dd" :input-class="{'special-days-date-picker-filled' : newSpecialDate, 'special-days-date-picker-empty': !newSpecialDate}" v-model="newSpecialDate" format="yyyy-MM-dd"></datepicker>
                    </div>
                    <div class="form-group col-md-4" :class="newSpecialDescription ? 'has-success' : 'has-warning'">
                        <label class="col-md-3 form-control-label">Description</label>
                        <textarea class="form-control" v-model="newSpecialDescription" placeholder="e.g. 'Jāņu diena' or 'Pārceltā darba diena no 01.01.2018'"></textarea>
                    </div>
                    <div class="form-group col-md-3" :class="newSpecialDeltaT ? 'has-success' : 'has-danger'">
                        <label class="col-md-3 form-control-label">Δ Time</label>
                        <div class="input-group">
                            <input type="number" v-model.number="newSpecialDeltaT" placeholder="Hover over for info" class="form-control" 
                                title="Positive number (e.g. 8 or 2) for shorter day, negative (e.g. -8 or -1.5) for longer day">
                            <span class="input-group-addon">h</span>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <button style="margin-top: 29px; width: 100%;" class="btn btn-primary" @click="saveSpecialDay()">Save</button>
                    </div>
                </div>
            </div>    
        </div>
        <div class="card">
            <div class="card-header">
                <i class="fa fa-calendar" aria-hidden="true"></i>
                Special days
            </div>
            <div class="card-block">    
                <table class="table no-padding">
                    <thead>
                        <th>#</th>
                        <th>Date</th>
                        <th>Description</th>
                        <th>Δ Time</th>
                        <th>Actions</th>
                    </thead>
                    <tbody>
                        <tr v-for="specialDay in specialBusinessDays">
                            <td>{{specialDay.id}}</td>
                            <td>{{specialDay.date}}</td>
                            <td>{{specialDay.description}}</td>
                            <td>{{specialDay.delta_time.toFixed(1)}}</td>
                            <td>
                                <i @click="deleteSpecialDay(specialDay.id)" class="fa fa-trash fa-lg action" aria-hidden="true"></i>
                                <i @click="editSpecialDay(specialDay)" class="fa fa-pencil-square-o fa-lg action" aria-hidden="true"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <modal title="Modal title" v-model="editSpecialDayModal" @ok="updateSpecialDay" ok-disabled="true" effect="fade/zoom">
            <div slot="modal-header" class="modal-header">
                <h4 class="modal-title">Edit Special Day</h4>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Date</label>
                <div class="col-md-9">
                    <datepicker  placeholder="yyyy-mm-dd" input-class="edit-special-days-date-picker" v-model="editSpecialDate" format="yyyy-MM-dd"></datepicker>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Description</label>
                <div class="col-md-9">
                    <textarea class="form-control" v-model="editSpecialDescription"></textarea>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Δ Time</label>
                <div class="col-md-9 input-group">
                    <input type="number" class="form-control" v-model="editSpecialDeltaT">
                </div>
            </div>
        </modal>
    </div>
</template>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';
import modal from 'vue-strap/src/Modal';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'SpecialBusinessDays',
  data() {
    return {
      newSpecialDate: null,
      newSpecialDescription: '',
      newSpecialDeltaT: null,

      editSpecialDate: null,
      editSpecialDescription: '',
      editSpecialDeltaT: null,
      editSpecialId: null,
      editSpecialDayModal: false,
    };
  },
  components: {
    modal,
    Datepicker
  },
  computed: {
    ...mapGetters('SpecialBusinessDays', ['specialBusinessDays'])
  },
  methods: {
    ...mapActions('SpecialBusinessDays', ['SAVE_SPECIAL_DAY', 'LOAD_SPECIAL_DAYS', 'DELETE_SPECIAL_DAY']),
    saveSpecialDay() {
      this.SAVE_SPECIAL_DAY({ date: moment(this.newSpecialDate).format('YYYY-MM-DD'), description: this.newSpecialDescription, deltaTime: this.newSpecialDeltaT });
    },
    editSpecialDay(specialBusinessDay) {
      this.editSpecialId = specialBusinessDay.id;
      this.editSpecialDate = specialBusinessDay.date;
      this.editSpecialDescription = specialBusinessDay.description;
      this.editSpecialDeltaT = specialBusinessDay.delta_time;
      this.editSpecialDayModal = true;
    },
    deleteSpecialDay(id) {
      this.DELETE_SPECIAL_DAY(id);
    },
    updateSpecialDay() {
      this.SAVE_SPECIAL_DAY({
        id: this.editSpecialId,
        date: moment(this.editSpecialDate).format('YYYY-MM-DD'),
        description: this.editSpecialDescription,
        deltaTime: this.editSpecialDeltaT,
      });
      this.editSpecialDayModal = false;
    }
  },
  mounted() {
    this.LOAD_SPECIAL_DAYS();
  },
};
</script>
<style lang="scss" scoped>
    table.no-padding * {
        padding: 0;
    }
    label {
        white-space: nowrap;
    }
    .action {
        margin-left: 5px;

        &:hover {
            cursor: pointer;
            color: #ee0044;
        }
    }
</style>
<style>
    .edit-special-days-date-picker {
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: #607d8b;
        padding: 0.4rem 0.75rem;
    }
    .special-days-date-picker-empty {
        width: 100%;
        border: 1px solid #f86c6b;
        color: #607d8b;
        padding: 0.4rem 0.75rem;
    }
    .special-days-date-picker-filled {
        width: 100%;
        border: 1px solid #4dbd74;
        color: #607d8b;
        padding: 0.4rem 0.75rem;
    }
</style>
